<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="taskTypeId"
          table-no="mstTaskTypeSetting"
          table-api="master/task-type-setting"
          ref="commonMasterTable"
          v-on:check-remove="onRemoveChecked"
          :is-check-all="isRemoveCheck"
          :editable="editableMixin.taskTypeSetting"
          :addable="editableMixin.taskTypeSetting"
          :mapping-no="`ie-task-type-setting`"
          :hideButtonImportCsv="true"
          socket-entity="TASK_TYPE_SETTING_MST_SOCKET"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      isRemoveCheck: false,
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {
    /**
     * チェックした削除アイテムのキーリスト取得
     */
    onRemoveChecked(removeObj) {
      this.removeKeys = removeObj.data
      if (removeObj.checkall_flag) this.isRemoveCheck = removeObj.checkall_flag
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/TaskTypeSettingMaster.vue